const storage = window.localStorage
export default {
    set(key,val) {
        storage.setItem(key,JSON.stringify(val))
    },
    get(key) {
        let item = storage.getItem(key);
        if (!item) return null
        item = JSON.parse(item)
        return item
    },
    remove(key) {
        storage.removeItem(key)
    },
    // 清除所有值
    clearAllItem() {
        storage.clear()
    }
}